module.exports = __webpack_public_path__ + "img/1.c67cd73f.png";